import React from "react";

import { Box } from "@mui/material";

import { Trans, } from "@lingui/macro";

import { Link, Redirect } from "react-router-dom";

import ArrowBackIcon from "@mui/icons-material/ArrowBack";


import "./style.scss";
import RegistrationForm from "components/registration/registration-form";

export class Registration extends React.Component<{}, {}>
{
	render() {

		let allowRegistration = process.env.REACT_APP_ALLOW_REGISTRATION === "true"

		return (
			<Box className={"registration-container"}>
				{!allowRegistration && <Redirect to="/"></Redirect>}
				<Box className={"grid-item-logo"}>
					<Link to={"/"} className={"registration-logo"}>
						<img src={`${process.env.PUBLIC_URL}/loaded-files/${process.env.REACT_APP_LOGO_FILENAME}`}
							alt={"Logo"} />
					</Link>
				</Box>
				<Box className={"grid-item-form"} >
					<RegistrationForm />
					<Box className="link-go-back">
						<Link to={"/"} style={{
							display: "flex",
							alignItems: "center",
							color: "black",
							marginTop: "10px",
							fontSize: "15px",
						}}><ArrowBackIcon fontSize="small" /><Trans id="reg-back-link">Torna alla home</Trans></Link>
					</Box>
				</Box>
			</Box>);
	}
}
